'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("chartUtils", function (objectUtils, $interpolate, contrepartieService, tlColors, colorUtils) {
  var chartColors = [tlColors.NEW_BLUE_1, tlColors.NEW_ORANGE_1, tlColors.NEW_GREEN_1, tlColors.NEW_PURPLE_1, tlColors.NEW_LIGHT_BLUE, tlColors.NEW_ORANGE_2, tlColors.NEW_GREEN_4, tlColors.NEW_BLUE_2, tlColors.NEW_RED_1, tlColors.NEW_GREEN_3, tlColors.NEW_PURPLE_2];
  var tooltipTpl = '<span style="color: {{color}}; font-weight: {{weight}};">{{content}}</span>';
  var tooltipInterpolation = $interpolate(tooltipTpl);
  return {
    PLOT_LINE_COLOR: '#4DC100',
    /**
     * Creates an html span element displayable in highchart tooltip element.
     * @param content The content to display
     * @param options The options for the span element :
     *      - color [default : black] : the color of the element.
     *      - bold  [default : false] : if set to true, text will appear in bold.
     *      - br    [default : false] : if set to true, will append a <br/> tag to the end of the element.
     * @return {String} the html of the span
     */
    tooltipElement: function tooltipElement(content, options) {
      var o = options || {};
      var scope = {
        content: content,
        color: o.color || "black",
        weight: o.bold ? "bold" : "normal"
      };
      var html = tooltipInterpolation(scope);
      if (o.br) {
        html += "<br/>";
      }
      return html;
    },
    mapAndFilter: function mapAndFilter(serie, xAttribute, yAttribute, mapFct) {
      serie = this.filterEmptyValues(serie, xAttribute, yAttribute);
      var isDateAxis = serie.length > 0 && objectUtils.getProperty(serie[0], xAttribute) instanceof Date;
      serie = _.map(serie, mapFct || function (point) {
        return {
          x: isDateAxis ? objectUtils.getProperty(point, xAttribute).getTime() : objectUtils.getProperty(point, xAttribute),
          y: objectUtils.getProperty(point, yAttribute)
        };
      });
      return serie;
    },
    /**
     * ex : chartUtils.map(data, "date", "crd.valeur", {"devise": "crd.devise"})
     */
    map: function map(serie, xAttribute, yAttribute, otherAttributes) {
      serie = this.filterEmptyValues(serie, xAttribute, yAttribute);
      var isDateAxis = serie.length > 0 && objectUtils.getProperty(serie[0], xAttribute) instanceof Date;
      serie = _.map(serie, function (point) {
        var res = {
          x: isDateAxis ? objectUtils.getProperty(point, xAttribute).getTime() : objectUtils.getProperty(point, xAttribute),
          y: objectUtils.getProperty(point, yAttribute)
        };
        _.each(otherAttributes, function (property, name) {
          res[name] = objectUtils.getProperty(point, property);
        });
        return res;
      });
      return serie;
    },
    filterEmptyValues: function filterEmptyValues(items, xAttribute, yAttribute) {
      items = _.filter(items, function (item) {
        return objectUtils.getProperty(item, xAttribute) != null && objectUtils.getProperty(item, yAttribute) != null;
      });
      return items;
    },
    getDateVisualisationPlotLine: function getDateVisualisationPlotLine(contextService, dateVisualisation) {
      return [{
        color: '#4DC100',
        width: 2,
        value: (dateVisualisation || contextService.getContext().dateVisualisation).getTime(),
        zIndex: 5
      }];
    },
    getDateMarchePlotLine: function getDateMarchePlotLine(contextService) {
      return [{
        color: '#4DC100',
        width: 2,
        value: contextService.getContext().dateVisualisation.getTime(),
        zIndex: 5,
        label: {
          text: 'anticipés'
        }
      }];
    },
    getGraphColors: function getGraphColors() {
      return chartColors;
    },
    /**
     *
     * @param index index of the color in the chartColors array
     * @returns {string}
     */
    getGraphColor: function getGraphColor(index) {
      return chartColors[index % chartColors.length];
    },
    /**
     *
     * @param index index of the color in the chartColors array
     * @param opacity opacity to add (ex: 0.5)
     * @returns {string}
     */
    getGraphColorWithOpacity: function getGraphColorWithOpacity(index, opacity) {
      var color = chartColors[index % chartColors.length];
      if (opacity) {
        var hexToRgb = colorUtils.hexToRgb(color);
        color = "rgb(" + hexToRgb[0] + "," + hexToRgb[1] + "," + hexToRgb[2] + "," + opacity + ")";
      }
      return color;
    },
    darkenColor: function darkenColor(hex, ratio) {
      if (!hex || typeof hex !== 'string') {
        return hex;
      }
      if (hex.indexOf('#') === 0 && hex.length === 7) {
        var r = parseInt(hex.substring(1, 3), 16);
        var g = parseInt(hex.substring(3, 5), 16);
        var b = parseInt(hex.substring(5, 7), 16);
        r = Math.max(0, Math.floor(r * (1 - ratio)));
        g = Math.max(0, Math.floor(g * (1 - ratio)));
        b = Math.max(0, Math.floor(b * (1 - ratio)));
        var toHex = function toHex(val) {
          return ('0' + val.toString(16)).slice(-2);
        };
        return '#' + toHex(r) + toHex(g) + toHex(b);
      }
      return hex;
    },
    getGraphColorsForId: function getGraphColorsForId(id) {
      var color = contrepartieService.getContrepartieColor(id);
      if (color != null) {
        return color;
      }
      /* jshint bitwise:false */
      var hashCode = id.split("").reduce(function (a, b) {
        a = (a << 5) - a + b.charCodeAt(0);
        return a & a;
      }, 0);
      /* jshint bitwise:true */
      var index = Math.abs(hashCode) % chartColors.length;
      return chartColors[index];
    },
    /**
     *
     * @param title
     * @returns la configuration standard des pie charts
     */
    getDefautPieChartsConfig: function getDefautPieChartsConfig(title) {
      return {
        options: {
          chart: {
            type: 'pie',
            height: 250
          },
          tooltip: {
            crosshairs: false,
            pointFormat: '<b>{point.percentage:.1f}%</b>'
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                connectorWidth: 1,
                distance: 10,
                formatter: function formatter() {
                  return this.point.name + '<br/>' + Math.round(this.percentage) + ' %';
                }
              },
              innerSize: '60%'
            }
          },
          title: {
            text: title
          }
        }
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/chartUtils.js
// module id = 2745
// module chunks = 13